import React, { useMemo } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { useStrapiConfig } from "hooks/useStrapiConfig";
import { buildThemeFromStyleConfig } from "theme";

// Theme depends on the Strapi config, which is only known after the first
// fetch resolves — falls back to the default theme (built from an empty
// style config) while loading, so there's no flash of unstyled content
// beyond what LayoutSkeleton already covers.
const DynamicThemeProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const { data: loginPageConfig } = useStrapiConfig();
  const theme = useMemo(() => buildThemeFromStyleConfig(loginPageConfig?.login_page_style), [loginPageConfig]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default DynamicThemeProvider;
